import { ApolloClient, ApolloLink, InMemoryCache, HttpLink } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";
import { ApolloProvider } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";

import { registerAccessTokenGetter } from "./modules/auth/accessToken";

export default function ApolloProviderWithAuthToken(props) {
    const { getAccessTokenSilently } = useAuth0();

    // the taxonomy clients are built outside React but now call the gateway,
    // so they need the same token this provider already fetches
    registerAccessTokenGetter(
        async () => {
            try {
                return await getAccessTokenSilently(
                    { authorizationParams: { audience: "https://api.bimproject.cloud" } }
                );
            } catch {
                return undefined;
            }
        }
    );

    const client = useMemo(
        () => {
            const httpLink = new HttpLink({ uri: "https://api.bimproject.cloud/graphql" });

            const authLink = new SetContextLink(
                async ({ headers }) => {
                    try {
                        const token = await getAccessTokenSilently(
                            {
                                authorizationParams: {
                                    audience: "https://api.bimproject.cloud",
                                },
                            }
                        );
                        return {
                            headers: {
                                ...headers,
                                Authorization: token ? `Bearer ${token}` : "",
                            },
                        };
                    } catch {
                        return {};
                    }
                }
            );

            return new ApolloClient(
                {
                    link: ApolloLink.from(
                        [
                            authLink,
                            httpLink,
                        ]
                    ),
                    cache: new InMemoryCache(),
                }
            );
        },
        [],
    );

    return (
        <ApolloProvider
            {...props}
            client={client}
        />
    );
}
